import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";

import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepSpecific from "../../../../../../hooks/useStepSpecific";
import React from "react";
import { createFormalValidationFromSchema } from "../../../../../../yup/utils/yupUtils";
import { createAdditionalDocDetailsValidationSchemas } from "../../../../../../yup/additionalDoc/AdditionalDocDetailsValidationSchemas";
import {
  completeAdditionalDocDetailStep,
  setStepAdditionalDocDetailEdited,
} from "../../../../../../store/redux/slice/Forms/seAdditionalDocForm";
import AdditionalDocStepDetails from "./AdditionalDocStepDetails";
import { initialSeAdditionalDocApplication } from "../../../../../../init/seAdditionalDocInitialValues";

const SeAdditionalDocStepDetails = () => {
  const seAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.SeAdditionalDocForm;
  });

  const fullSchema = createAdditionalDocDetailsValidationSchemas;
  const formalSchema = createFormalValidationFromSchema(fullSchema);

  const { onSubmit, methods } = useStepSpecific(
    seAdditionalDocForm.additionalDocDetail,
    seAdditionalDocForm.id,
    baseEndpointPaths.seAdditionalDoc,
    formalSchema,
    setStepAdditionalDocDetailEdited,
    completeAdditionalDocDetailStep,
    initialSeAdditionalDocApplication,
  );

  useFormReset("SECONDARY_ADDITIONAL_DOCUMENTS", seAdditionalDocForm.additionalDocDetail, methods.reset);

  return (
    <AdditionalDocStepDetails
      fullSchema={fullSchema}
      formalSchema={formalSchema}
      methods={methods}
      onSubmit={onSubmit}
    />
  );
};
export default SeAdditionalDocStepDetails;
